import {Injectable, signal} from '@angular/core';

@Injectable()
export class WindowSizeService {
  public windowSize = signal<Array<number>>(null);

  constructor() {}

  public UpdateWindowSize(size: Array<number>): void {
    this.windowSize.set(size);
  }
}
